import {
  DCRequest_DCRequestTransAttributes_GETROW,
  DCRequest_DCGroupSearchTyp_GETROW,
  DCRequest_DCRequestLoadGrid_GETROW,
  DCRequest_DCRequestSaveHead_GETROW,
  DCRequest_DCRequestSaveDetail_GETROW,
  DCRequest_DCRequestDisplay_GETROW,
  DCRequest_DCRequestItemsDetail_GETROW,
} from "../../Server/ApiV2";

import moment from "moment";

import { vRdxUserInfo, RoDCRequest } from "../../Redux/roStore";
import {
  fcheck_null_undefine_replace_empty,
  fAlertToast,
  Get_TransItemStockUOM,
} from "../../Utility/Utilitys";
import { fExecuteAPI } from "./../../Server/Apis";
import {
  Set_DCRequest_HeadObject_VocNo_DocSt,
  Set_DCRequest_HeadObject,
} from "./SliceDCRequest";
export const vBufferObjInit = {
  B_SrNo: 0,
  B_ItmCd: "",
  ItmName: "",
  B_Stk_Days: 0,
  B_Sfty_Days: 0,
  B_Max_Days: 0,
  B_LD_Days: 0,
  B_Cnsm: 0,
  B_Stock: 0,
  B_BalQty: 0,
  B_Stock_DC: 0,
  B_ROP: 0,
  B_ROQ: 0,
  B_Req_Qty: 0,
  B_PU_Unit: "",
  B_PU_UnitName: "",
  B_PU_PackQty: 0,
  B_PU_Consm: 0,
  B_PU_Stock: 0,
  B_PU_ROP: 0,
  B_PU_ROQ: 0,
  B_Priority: "",
  B_Projection: 0,
  B_DC_RSP_Final: 0,
  B_RSP: 0,
  B_GP: 0,
  B_GPPerc: 0,
  B_PU_REQ_Qty: 0,
  RbtPerc: 0,
  RbtAmt: 0,
  CNPerc: 0,
  CNAmt: 0,
  Res1Amt: 0,
  Res2Amt: 0,
  Res3Amt: 0,
  Res4Amt: 0,
  Res5Amt: 0,
  B_DC_RSP: 0,
};
export const ErrorMsg = {
  A_VocTyp: "",
  A_VocName: "",
  A_VocNo: "",
  A_VocDt: "",
  A_Loc: "",
  LocName: "",
  A_AcCd: "",
  A_AcName: "",
  A_CrLimit: "",
  A_OsAmt: "",
  A_MainGrp: "",
  MainGrpName: "",
  A_SubGrp: "",
  SubGrpName: "",
  A_Grp: "",
  GrpName: "",
  A_Brand: "",
  BrandName: "",
  A_LeadDays: "",
  A_DocStat: "",
  A_DCLoc: "",
  DCLocName: "",
  PrmCd: "",
  A_CNSM_Type: "",
  A_CNSM_From: "",
  A_CNSM_To: "",
  A_Total_Val: "",
  WHLoc: "",
};
export const ErrorMsgDetail = {
  B_ItmCd: "",
  ItmName: "",
  B_PU_Unit: "",
  B_PU_UnitName: "",
  B_PU_PackQty: "",
  B_PU_REQ_Qty: "",
  B_SrNo:""
};

var vheaderArrow = 0;
export const fRightClick = (e) => {
  vheaderArrow = vheaderArrow !== 1 ? vheaderArrow + 1 : 1;

  const headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  headerMainTag.forEach((element, index) => {
    if (vheaderArrow === index) {
      element.classList.add("main-wms-sales-invoice-show-sm");
    } else {
      element.classList.remove("main-wms-sales-invoice-show-sm");
    }
  });
};

export const fLeftClick = (e) => {
  vheaderArrow = vheaderArrow !== 0 ? vheaderArrow - 1 : 0;

  const headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  headerMainTag.forEach((element, index) => {
    if (vheaderArrow === index) {
      element.classList.add("main-wms-sales-invoice-show-sm");
    } else {
      element.classList.remove("main-wms-sales-invoice-show-sm");
    }
  });
};

export const Data_Grid_Column_Head = [
  {
    field: "UId",
    headerName: "LocCd",
    width: 150,
  },
  {
    field: "Name1",
    headerName: "LocName",
    width: 220,
  },
  {
    field: "L_Chk",
    headerName: "Selected",
    width: 150,
    hide: true,
  },
];
export const Data_Grid_Detail_Column = [
  // { field: "B_VocTyp", headerName: "B_VocTyp", width: 90, hide: false },
  // { field: "VocName", headerName: "VocName", width: 90, hide: false },
  // { field: "B_VocNo", headerName: "B_VocNo", width: 90, hide: false },
  { field: "Selected", headerName: "Selected", width: 90, hide: true },
  { field: "Flg", headerName: "Flg", width: 90, hide: true },
  { field: "B_SrNo", headerName: "B_SrNo", width: 90, hide: false },
  { field: "B_ItmCd", headerName: "B_ItmCd", width: 90, hide: false },
  { field: "ItmName", headerName: "ItmName", width: 90, hide: false },
  {
    field: "B_Stk_Days",
    headerName: "B_Stk_Days",
    width: 90,
    hide: false,
  },
  {
    field: "B_Sfty_Days",
    headerName: "B_Sfty_Days",
    width: 90,
    hide: false,
  },
  {
    field: "B_Max_Days",
    headerName: "B_Max_Days",
    width: 90,
    hide: false,
  },
  {
    field: "B_LD_Days",
    headerName: "B_LD_Days",
    width: 90,
    hide: false,
  },
  { field: "B_Cnsm", headerName: "B_Cnsm", width: 90, hide: false },
  { field: "B_Stock", headerName: "B_Stock", width: 90, hide: false },
  { field: "B_BalQty", headerName: "B_BalQty", width: 90, hide: false },
  {
    field: "B_Stock_DC",
    headerName: "B_Stock_DC",
    width: 90,
    hide: false,
  },
  { field: "B_ROP", headerName: "B_ROP", width: 90, hide: false },
  { field: "B_ROQ", headerName: "B_ROQ", width: 90, hide: false },
  {
    field: "B_Req_Qty",
    headerName: "B_Req_Qty",
    width: 90,
    hide: false,
  },
  {
    field: "B_PU_Unit",
    headerName: "B_PU_Unit",
    width: 90,
    hide: false,
  },
  {
    field: "B_PU_UnitName",
    headerName: "B_PU_UnitName",
    width: 90,
    hide: false,
  },
  {
    field: "B_PU_PackQty",
    headerName: "B_PU_PackQty",
    width: 90,
    hide: false,
  },
  {
    field: "B_PU_Consm",
    headerName: "B_PU_Consm",
    width: 90,
    hide: false,
  },
  {
    field: "B_PU_Stock",
    headerName: "B_PU_Stock",
    width: 90,
    hide: false,
  },
  { field: "B_PU_ROP", headerName: "B_PU_ROP", width: 90, hide: false },
  { field: "B_PU_ROQ", headerName: "B_PU_ROQ", width: 90, hide: false },
  {
    field: "B_Priority",
    headerName: "B_Priority",
    width: 90,
    hide: false,
  },
  {
    field: "B_Projection",
    headerName: "B_Projection",
    width: 90,
    hide: false,
  },
  {
    field: "B_DC_RSP_Final",
    headerName: "B_DC_RSP_Final",
    width: 90,
    hide: false,
  },
  { field: "B_RSP", headerName: "B_RSP", width: 90, hide: false },
  { field: "B_GP", headerName: "B_GP", width: 90, hide: false },
  { field: "B_GPPerc", headerName: "B_GPPerc", width: 90, hide: false },
  {
    field: "B_PU_REQ_Qty",
    headerName: "B_PU_REQ_Qty",
    width: 90,
    hide: false,
  },
  { field: "RbtPerc", headerName: "RbtPerc", width: 90, hide: false },
  { field: "RbtAmt", headerName: "RbtAmt", width: 90, hide: false },
  { field: "CNPerc", headerName: "CNPerc", width: 90, hide: false },
  { field: "CNAmt", headerName: "CNAmt", width: 90, hide: false },
  { field: "Res1Amt", headerName: "Res1Amt", width: 90, hide: false },
  { field: "Res2Amt", headerName: "Res2Amt", width: 90, hide: false },
  { field: "Res3Amt", headerName: "Res3Amt", width: 90, hide: false },
  { field: "Res4Amt", headerName: "Res4Amt", width: 90, hide: false },
  { field: "Res5Amt", headerName: "Res5Amt", width: 90, hide: false },
  { field: "B_DC_RSP", headerName: "B_DC_RSP", width: 90, hide: false },
];

export const GetAttributes = async (
  setDocumentTypeData,
  setLoactionData,
  setDCLoactionData,
  setObjectRights,
  setUser_Doc_Arr
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var vDCRequestObj = {
    userCode: vRdxUserInfoObj.UserID,
    userGroupCode: vRdxUserInfoObj.UserGroupCode,
  };
  const vDCRequestTransAttributes =
    await DCRequest_DCRequestTransAttributes_GETROW(vDCRequestObj);
  if (vDCRequestTransAttributes?.status === 200) {
    setDocumentTypeData(vDCRequestTransAttributes?.data?.ResultSet?.DocTypes);
    setLoactionData(vDCRequestTransAttributes?.data?.ResultSet?.LocationList);
    setDCLoactionData(vDCRequestTransAttributes?.data?.ResultSet?.DCloc);
    setObjectRights(vDCRequestTransAttributes?.data?.ResultSet?.Rights);
    setUser_Doc_Arr(vDCRequestTransAttributes?.data?.ResultSet?.UserDoc);
    return vDCRequestTransAttributes?.data?.ResultSet;
  } else {
    return [];
  }
};

export const GetDCGroupSearchTyp = async (
  xAnyData = "",
  xTitle = "",
  xSearchTyp = "",
  xPrnt = "",
  xLvl = "",
  xCd = "",
  xName = "",
  set_DataGrid_GCSimpleSearch_Row = () => {}
) => {
  const iDCGRoup = {
    AnyData: xAnyData,
    Cd: xCd,
    Name: xName,
    Prnt: xPrnt,
    Lvl: xLvl,
    SearchTyp: xSearchTyp,
    Title: xTitle,
  };
  let iResp = await DCRequest_DCGroupSearchTyp_GETROW(iDCGRoup);
  console.log(iResp);
  if (iResp.status === 200 && xSearchTyp === "Y") {
    return iResp?.data?.ResultSet;
  } else if (iResp.status === 200 && xSearchTyp === "N") {
    let GridID = iResp?.data?.ResultSet?.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    set_DataGrid_GCSimpleSearch_Row(GridID);
  } else {
    fAlertToast(
      "FAILED",
      iResp.response.data.status
        ? iResp.response.data.status
        : "Error in loading SrcDoc"
    );
    return [];
  }
};
//API
export const GetItemFullSearchArr = async (xItemName, xLoc) => {
  let vItemFullSearchDataObj = {
    anyData: xItemName,
    transType: "F",
    report: "Y",
    loc: xLoc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemFullSearchDataObj);

  const vItemSearchFull = await fExecuteAPI(
    // "ITEM_SEARCHFULL_GETROW",
    "SEARCHEXACTITEM_GETROW",
    FinalObj
  );
  //status code "" so Success is checked
  if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
    if (vItemSearchFull.ResultSet.length > 0) {
      return vItemSearchFull.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      vItemSearchFull.Type.response.data.message
        ? vItemSearchFull.Type.response.data.message
        : "Error in vItemSearchFullArr"
    );
    return [];
  }
};

//API Unit GETITEMUNITSINBOUND_GETROW
export const GetUnitArr = async (xItemCode, setUnit) => {
  let itemUnitobj = {
    itemCd: xItemCode,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(itemUnitobj);

  const UnitInfo = await fExecuteAPI("GETITEMUNITS_GETROW", FinalObj);
  if (UnitInfo?.Type?.toUpperCase() === "SUCCESS") {
    if (UnitInfo.ResultSet.length > 0) {
      setUnit(UnitInfo.ResultSet);
      return UnitInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      UnitInfo.Type.response.data.message
        ? UnitInfo.Type.response.data.message
        : "Error in UnitArr"
    );
    return [];
  }
};
//TODO FULLSEARCH ,UNITARR ,AND CALCULATION
export const fItemCodeDependency = async (
  vItemSearchFull,
  setBufferObj,
  setUnit
) => {
  if (vItemSearchFull.length > 0) {
    const { HeadObject } = RoDCRequest();

    let vItemDetail = {
      vocTyp: HeadObject.A_VocTyp,
      vocNo: HeadObject.A_VocNo,
      itemcode: vItemSearchFull[0].ItmCd,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vItemDetail);

    const iSIDetailResult = await DCRequest_DCRequestItemsDetail_GETROW(
      FinalObj
    );

    if (iSIDetailResult?.status === 200) {
      setBufferObj((obj) => ({
        ...obj,
        B_ItmCd: vItemSearchFull[0].ItmCd,
        ItmName: vItemSearchFull[0].Name2,
        B_Stk_Days: iSIDetailResult?.data?.ResultSet[0]?.B_Stk_Days,
        B_Sfty_Days: iSIDetailResult?.data?.ResultSet[0]?.B_Sfty_Days,
        B_Max_Days: iSIDetailResult?.data?.ResultSet[0]?.B_Max_Days,
        B_LD_Days: iSIDetailResult?.data?.ResultSet[0]?.B_LD_Days,
        B_Cnsm: iSIDetailResult?.data?.ResultSet[0]?.B_Cnsm,
        B_Stock: iSIDetailResult?.data?.ResultSet[0]?.B_Stock,
        B_Stock_DC: iSIDetailResult?.data?.ResultSet[0]?.B_Stock_DC,
        B_ROP: iSIDetailResult?.data?.ResultSet[0]?.B_ROP,
        B_ROQ: iSIDetailResult?.data?.ResultSet[0]?.B_ROQ,
        B_Req_Qty: iSIDetailResult?.data?.ResultSet[0]?.B_Req_Qty,
        B_PU_Unit: iSIDetailResult?.data?.ResultSet[0]?.B_PU_Unit,
        B_PU_PackQty: iSIDetailResult?.data?.ResultSet[0]?.B_PU_PackQty,
        B_PU_Consm: iSIDetailResult?.data?.ResultSet[0]?.B_PU_Consm,
        B_PU_Stock: iSIDetailResult?.data?.ResultSet[0]?.B_PU_Stock,
        B_PU_ROP: iSIDetailResult?.data?.ResultSet[0]?.B_PU_ROP,
        B_PU_ROQ: iSIDetailResult?.data?.ResultSet[0]?.B_PU_ROQ[0],
        B_Priority: iSIDetailResult?.data?.ResultSet[0]?.B_Priority,
        B_Projection: iSIDetailResult?.data?.ResultSet[0]?.B_Projection,
        B_DC_RSP: iSIDetailResult?.data?.ResultSet[0]?.B_DC_RSP,
        B_RSP: iSIDetailResult?.data?.ResultSet[0]?.B_RSP,
        B_GP: iSIDetailResult?.data?.ResultSet[0]?.Gp,
        B_GPPerc: iSIDetailResult?.data?.ResultSet[0]?.GPPerc,
        // BalQty:iSIDetailResult?.data?.ResultSet[0]?.BalQty,
        Res1Amt: iSIDetailResult?.data?.ResultSet[0]?.Res1Amt,
        Res2Amt: iSIDetailResult?.data?.ResultSet[0]?.Res2Amt,
        Res3Amt: iSIDetailResult?.data?.ResultSet[0]?.Res3Amt,
        Res4Amt: iSIDetailResult?.data?.ResultSet[0]?.Res4Amt,
        Res5Amt: iSIDetailResult?.data?.ResultSet[0]?.Res5Amt,
        RbtPerc: iSIDetailResult?.data?.ResultSet[0]?.RbtPerc,
        RbtAmt: iSIDetailResult?.data?.ResultSet[0]?.RbtAmt,
        CNPerc: iSIDetailResult?.data?.ResultSet[0]?.CNPerc,
        CNAmt: iSIDetailResult?.data?.ResultSet[0]?.CNAmt,
      }));
    }
    await GetUnitArr(vItemSearchFull[0].ItmCd, setUnit);

    document.getElementsByName("B_Qty")[0]?.focus();
  } else {
    fAlertToast("FAILED", "Error in Exact Search");
  }
};

export const GetSearchItem = async (
  xData,
  xType,
  xA_Loc,
  setSearchGridData
) => {
  let vSeatchVendor = {
    Data: xData,
    Type: xType,
    Loc: xA_Loc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSeatchVendor);
  const vItemSearch = await fExecuteAPI("SEARCHITEM001_GETROW", FinalObj);
  if (vItemSearch.Type === "SUCCESS") {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setSearchGridData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.response.data.message
        ? vItemSearch.response.data.message
        : "Error in SearchItem"
    );
  }
};
export const GridDataColumnsItemSearch_Def = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "ItmCd", headerName: "ItmCd", width: 90 },
  { field: "Name1", headerName: "Name1", width: 450 },
  { field: "NameFL", headerName: "NameFL", width: 90 },
  { field: "MainGrpName", headerName: "MainGrpName", width: 90 },
  { field: "SuppRefNo1", headerName: "SuppRefNo1", width: 90 },
  { field: "Model", headerName: "Model", width: 90 },
  { field: "BaseUnitName", headerName: "BaseUnitName", width: 90 },
  { field: "BarCode", headerName: "BarCode", width: 90 },
];
export const ItemSearchData = [
  "Any",
  "Code",
  "Name",
  "Barcode",
  "Group",
  "RefNo",
  "NameFL",
  "CostPrice",
  "RSP",
];
//API GETSIDETAILS_GETROW
export const GetSIDetail = async (xB_VocNo, xVocTyp, set_Grid_Detail_Rows) => {
  // const { HeadObject } = RoDCRequest();
  let iSIDetailObj = {
    v_A_VocTyp: !!xVocTyp ? xVocTyp : "",
    v_A_VocNo: !!xB_VocNo ? xB_VocNo : 0,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(iSIDetailObj);

  const iSIDetailResult = await DCRequest_DCRequestLoadGrid_GETROW(FinalObj);
  if (iSIDetailResult?.status === 200) {
    if (iSIDetailResult?.data?.ResultSet?.length > 0) {
      set_Grid_Detail_Rows(iSIDetailResult?.data?.ResultSet);
      return iSIDetailResult?.data?.ResultSet;
    } else {
      set_Grid_Detail_Rows([]);
      return [];
    }
  }
};
export const fValidationHead_Client = (vRdxHead, setErrorMsg) => {
  let iRes = true;

  if (
    vRdxHead.A_VocTyp === "" ||
    vRdxHead.A_VocTyp === null ||
    vRdxHead.A_VocTyp === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_VocTyp: "VocTyp should not be empty",
    }));
    fAlertToast("INFO", "VocTyp should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_VocName === "" ||
    vRdxHead.A_VocName === null ||
    vRdxHead.A_VocName === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_VocName: "VocName should not be empty",
    }));
    fAlertToast("INFO", "VocName should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_VocNo === "" ||
    vRdxHead.A_VocNo === null ||
    vRdxHead.A_VocNo === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_VocNo: "VocNo should not be empty",
    }));
    fAlertToast("INFO", "VocNo should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_VocDt === "" ||
    vRdxHead.A_VocDt === null ||
    vRdxHead.A_VocDt === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_VocDt: "VocDt should not be empty",
    }));
    fAlertToast("INFO", "VocDt should not be empty");
    iRes = false;
  }

  let iDate = moment(vRdxHead.A_VocDt).format("MM/DD/YYYY");
  if (
    vRdxHead.A_VocDt === "Invalid Date" ||
    new Date(iDate) < new Date("01/01/1990")
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_VocDt: "VocDt date is invalid",
    }));
    fAlertToast("INFO", "VocDt date is invalid");
    iRes = false;
  }

  if (
    vRdxHead.A_Loc === "" ||
    vRdxHead.A_Loc === null ||
    vRdxHead.A_Loc === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_Loc: "Loc should not be empty",
    }));
    fAlertToast("INFO", "Loc should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.LocName === "" ||
    vRdxHead.LocName === null ||
    vRdxHead.LocName === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      LocName: "LocName should not be empty",
    }));
    fAlertToast("INFO", "LocName should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_CrLimit === "" ||
    vRdxHead.A_CrLimit === null ||
    vRdxHead.A_CrLimit === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_CrLimit: "CrLimit should not be empty",
    }));
    fAlertToast("INFO", "CrLimit should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_OsAmt === "" ||
    vRdxHead.A_OsAmt === null ||
    vRdxHead.A_OsAmt === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_OsAmt: "OsAmt should not be empty",
    }));
    fAlertToast("INFO", "OsAmt should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_LeadDays === "" ||
    vRdxHead.A_LeadDays === null ||
    vRdxHead.A_LeadDays === undefined ||
    vRdxHead.A_LeadDays <= 0
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_LeadDays: "LeadDays should not be empty",
    }));
    fAlertToast("INFO", "LeadDays should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_DocStat === "" ||
    vRdxHead.A_DocStat === null ||
    vRdxHead.A_DocStat === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_DocStat: "DocStat should not be empty",
    }));
    fAlertToast("INFO", "DocStat should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_DCLoc === "" ||
    vRdxHead.A_DCLoc === null ||
    vRdxHead.A_DCLoc === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_DCLoc: "DCLoc should not be empty",
    }));
    fAlertToast("INFO", "DCLoc should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.DCLocName === "" ||
    vRdxHead.DCLocName === null ||
    vRdxHead.DCLocName === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      DCLocName: "DCLocName should not be empty",
    }));
    fAlertToast("INFO", "DCLocName should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_CNSM_Type === "" ||
    vRdxHead.A_CNSM_Type === null ||
    vRdxHead.A_CNSM_Type === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_CNSM_Type: "CNSM_Type should not be empty",
    }));
    fAlertToast("INFO", "CNSM_Type should not be empty");
    iRes = false;
  }

  if (vRdxHead.A_CNSM_Type === "Period") {
    if (
      vRdxHead.A_CNSM_From === "" ||
      vRdxHead.A_CNSM_From === null ||
      vRdxHead.A_CNSM_From === undefined
    ) {
      setErrorMsg((obj) => ({
        ...obj,
        A_CNSM_From: "CNSM_From should not be empty",
      }));
      fAlertToast("INFO", "CNSM_From should not be empty");
      iRes = false;
    }

    if (
      vRdxHead.A_CNSM_To === "" ||
      vRdxHead.A_CNSM_To === null ||
      vRdxHead.A_CNSM_To === undefined
    ) {
      setErrorMsg((obj) => ({
        ...obj,
        A_CNSM_To: "CNSM_To should not be empty",
      }));
      fAlertToast("INFO", "CNSM_To should not be empty");
      iRes = false;
    }
    let iDate2 = moment(vRdxHead.A_CNSM_From).format("MM/DD/YYYY");
    if (
      vRdxHead.A_CNSM_From === "Invalid Date" ||
      new Date(iDate2) < new Date("01/01/1990")
    ) {
      setErrorMsg((obj) => ({
        ...obj,
        A_CNSM_From: "date is invalid",
      }));
      fAlertToast("INFO", "Date is invalid");
      iRes = false;
    }
    let iDate3 = moment(vRdxHead.A_CNSM_To).format("MM/DD/YYYY");
    if (
      vRdxHead.A_CNSM_To === "Invalid Date" ||
      new Date(iDate3) < new Date("01/01/1990")
    ) {
      setErrorMsg((obj) => ({
        ...obj,
        A_CNSM_To: "date is invalid",
      }));
      fAlertToast("INFO", "Date is invalid");
      iRes = false;
    }
    if (Date.parse(vRdxHead.A_CNSM_From) < Date.parse(vRdxHead.A_CNSM_To)) {
      setErrorMsg((obj) => ({
        ...obj,
        A_CNSM_From: "Expiry date should be greater then manufacturing date",
      }));
      fAlertToast("INFO", "Expiry date should be greater then manufacturing date");
      iRes = false;
    }
  }

  if (
    vRdxHead.A_Total_Val === "" ||
    vRdxHead.A_Total_Val === null ||
    vRdxHead.A_Total_Val === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_Total_Val: "Total_Val should not be empty",
    }));
    fAlertToast("INFO", "Total_Val should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.WHLoc === "" ||
    vRdxHead.WHLoc === null ||
    vRdxHead.WHLoc === undefined ||
    vRdxHead.WHLoc?.length === 0
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      WHLoc: "WHLoc should not be empty",
    }));
    fAlertToast("INFO", "WHLoc should not be empty");
    iRes = false;
  }

  return iRes;
};


export const fValidationDetail_Client = (sBufferObj, setErrorMsgDetail) => {
  let iRes = true;

  if (
    sBufferObj.B_SrNo === "" ||
    sBufferObj.B_SrNo === null ||
    sBufferObj.B_SrNo === undefined
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_SrNo: "Serial number should not be empty",
    }));
    fAlertToast("INFO", "Serial number should not be empty");
    iRes = false;
  }

  if (
    sBufferObj.B_ItmCd === "" ||
    sBufferObj.B_ItmCd === null ||
    sBufferObj.B_ItmCd === undefined
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_ItmCd: "Item code should not be empty",
    }));
    fAlertToast("INFO", "Item code should not be empty");
    iRes = false;
  }

  if (
    sBufferObj.ItmName === "" ||
    sBufferObj.ItmName === null ||
    sBufferObj.ItmName === undefined
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      ItmName: "Item name should not be empty",
    }));
    fAlertToast("INFO", "Item name should not be empty");
    iRes = false;
  }

  if (
    sBufferObj.B_PU_Unit === "" ||
    sBufferObj.B_PU_Unit === null ||
    sBufferObj.B_PU_Unit === undefined
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_PU_Unit: "Unit should not be empty",
    }));
    fAlertToast("INFO", "Unit should not be empty");
    iRes = false;
  }

  if (
    sBufferObj.B_PU_REQ_Qty === "" ||
    sBufferObj.B_PU_REQ_Qty === null ||
    sBufferObj.B_PU_REQ_Qty === undefined
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_PU_REQ_Qty: "Req qty should not be empty",
    }));
    fAlertToast("INFO", "Req qty should not be empty");
    iRes = false;
  }

  return iRes;
};

//API SaveSIHead
export const fSaveHead = async (
  xSave,
  dispatch,
  fLoad_Grid,
  setUser_Doc_Arr,
  fNewDetail,
  sBufferObj,
  xSaveType
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const { HeadObject } = RoDCRequest();
  const iStatus = xSave ? HeadObject.A_DocStat : "POST"; //xSave False means Post

  let vSaveSIHeadObj = {
    v_A_VocTyp: HeadObject.A_VocTyp,
    v_A_VocNo: HeadObject.A_VocNo,
    v_A_VocDt: moment(HeadObject.A_VocDt).format("MM/DD/YYYY"),
    v_A_Loc: HeadObject.A_Loc,
    v_A_MainGrp: HeadObject.A_MainGrp,
    v_A_SubGrp: HeadObject.A_SubGrp,
    v_A_Grp: HeadObject.A_Grp,
    v_A_Brand: HeadObject.A_Brand,
    v_A_LeadDays: HeadObject.A_LeadDays,
    v_A_DocStat: HeadObject.A_DocStat,
    v_A_DCLoc: HeadObject.A_DCLoc,
    v_UserCd: vRdxUserInfoObj.UserID,
    v_IP: vRdxUserInfoObj.IP,
    v_PrmCd: HeadObject.PrmCd,
    v_A_CNSM_Type: HeadObject.A_CNSM_Type,
    v_A_CNSM_From:
      HeadObject.A_CNSM_Type === "Period"
        ? moment(HeadObject.A_CNSM_From).format("MM/DD/YYYY")
        : "01/01/1900",
    v_A_CNSM_To:
      HeadObject.A_CNSM_Type === "Period"
        ? moment(HeadObject.A_CNSM_To).format("MM/DD/YYYY")
        : "01/01/1900",
    locs: HeadObject.WHLoc,
    Relase: xSaveType === "MainSave" ? false : true,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIHeadObj);

  const vSaveSIHead = await DCRequest_DCRequestSaveHead_GETROW(FinalObj);

  if (vSaveSIHead?.status === 200) {
    let iVocNo = xSave
      ? vSaveSIHead?.data?.ResultSet[0]?.VocNo
      : HeadObject.A_VocNo;

    if (Number(HeadObject.A_VocNo) === 0) {
      setUser_Doc_Arr((prevArr) => [
        ...prevArr,
        {
          A_VocTyp: HeadObject.A_VocTyp,
          A_VocNo: iVocNo,
          SrNo: prevArr.length + 1,
        },
      ]);
    }
    dispatch(
      Set_DCRequest_HeadObject_VocNo_DocSt({
        A_VocNo: iVocNo,
        A_DocStat: iStatus,
      })
    );
    if (xSaveType === "Release_Load") {
      fLoad_Grid(iVocNo, HeadObject.A_VocTyp);
    }
    //approve bool type false
    if (!xSave) {
      fDisplay(HeadObject.A_VocTyp, iVocNo, dispatch, fNewDetail);

      fAlertToast("SUCCESS", "Successfully posted");
    } else if (xSaveType === "MainSave") {
      fSaveDetail(iVocNo, sBufferObj, fNewDetail);
    }
  }
};
export const fDisplay = async (xA_VocTyp, A_VocNo, dispatch, fNewDetail) => {
  const { HeadObject } = RoDCRequest();
  let vSIHeadObj = {
    vocTyp: xA_VocTyp,
    vocNo: A_VocNo,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSIHeadObj);
  const vSIHead = await DCRequest_DCRequestDisplay_GETROW(FinalObj);

  if (vSIHead?.status === 200) {
    let HeadResp = fcheck_null_undefine_replace_empty(
      vSIHead?.data?.ResultSet[0]
    );
    dispatch(
      Set_DCRequest_HeadObject({
        ...HeadObject,
        A_VocTyp: HeadResp.A_VocTyp,
        A_VocTypName: HeadResp.VocName,
        A_VocNo: HeadResp.A_VocNo,
        A_VocDt: HeadResp.A_VocDt,
        A_Loc: HeadResp.A_Loc,
        LocName: HeadResp.LocName,
        A_MainGrp: HeadResp.A_MainGrp,
        MainGrpName: HeadResp.MainGrpName,
        A_SubGrp: HeadResp.A_SubGrp,
        SubGrpName: HeadResp.SubGrpName,
        A_Grp: HeadResp.A_Grp,
        GrpName: HeadResp.GrpName,
        A_Brand: HeadResp.A_Brand,
        BrandName: HeadResp.BrandName,
        A_LeadDays: HeadResp.A_LeadDays,
        A_DocStat: HeadResp.A_DocStat,
        A_DCLoc: HeadResp.A_DCLoc,
        DCLocName: HeadResp.DCLocName,
        PrmCd: HeadResp.PrmCd,
        A_CNSM_Type: HeadResp.A_CNSM_Type === "R" ? "Regular" : "Period",
        A_CNSM_From: HeadResp.A_CNSM_From,
        A_CNSM_To: HeadResp.A_CNSM_To,
        // A_CrLimit: 0,
        // A_OsAmt: 0,
        WHLoc: HeadResp.WHLoc,
      })
    );

    fNewDetail(
      vSIHead?.data?.ResultSet[0].A_VocNo,
      vSIHead?.data?.ResultSet[0].A_VocTyp
    );
  }
};

//API SAVESIDETAIL_GETROW
const fSaveDetail = async (xB_VocNo, sBufferObj, fNewDetail) => {
  const { HeadObject } = RoDCRequest();
  let vSaveSIDetailObj = {
    v_C_VocTyp: HeadObject.A_VocTyp,
    v_C_VocNo: xB_VocNo,
    Details: [
      {
        B_SrNo: sBufferObj.B_SrNo,
        B_ItmCd: sBufferObj.B_ItmCd,
        ItmName: sBufferObj.ItmName,
        B_Stk_Days: sBufferObj.B_Stk_Days,
        B_Sfty_Days: sBufferObj.B_Sfty_Days,
        B_Max_Days: sBufferObj.B_Max_Days,
        B_LD_Days: sBufferObj.B_LD_Days,
        B_Cnsm: sBufferObj.B_Cnsm,
        B_Stock: sBufferObj.B_Stock,
        B_BalQty: sBufferObj.B_BalQty,
        B_Stock_DC: sBufferObj.B_Stock_DC,
        B_ROP: sBufferObj.B_ROP,
        B_ROQ: sBufferObj.B_ROQ,
        B_Req_Qty: sBufferObj.B_Req_Qty,
        B_PU_Unit: sBufferObj.B_PU_Unit,
        B_PU_UnitName: sBufferObj.B_PU_UnitName,
        B_PU_PackQty: sBufferObj.B_PU_PackQty,
        B_PU_Consm: sBufferObj.B_PU_Consm,
        B_PU_Stock: sBufferObj.B_PU_Stock,
        B_PU_ROP: sBufferObj.B_PU_ROP,
        B_PU_ROQ: sBufferObj.B_PU_ROQ,
        B_Priority: sBufferObj.B_Priority,
        B_Projection: sBufferObj.B_Projection,
        B_DC_RSP_Final: sBufferObj.B_DC_RSP_Final,
        B_RSP: sBufferObj.B_RSP,
        B_GP: sBufferObj.B_GP,
        B_GPPerc: sBufferObj.B_GPPerc,
        B_PU_REQ_Qty: sBufferObj.B_PU_REQ_Qty,
        RbtPerc: sBufferObj.RbtPerc,
        RbtAmt: sBufferObj.RbtAmt,
        CNPerc: sBufferObj.CNPerc,
        CNAmt: sBufferObj.CNAmt,
        Res1Amt: sBufferObj.Res1Amt,
        Res2Amt: sBufferObj.Res2Amt,
        Res3Amt: sBufferObj.Res3Amt,
        Res4Amt: sBufferObj.Res4Amt,
        Res5Amt: sBufferObj.Res5Amt,
        B_DC_RSP: sBufferObj.B_DC_RSP,
      },
    ],
    BulkSave: false,
    Loc: HeadObject.A_Loc,
  };

  const vSaveSIDetail = await DCRequest_DCRequestSaveDetail_GETROW(
    vSaveSIDetailObj
  );
  if (vSaveSIDetail?.status === 200) {
    fNewDetail(xB_VocNo, HeadObject?.A_VocTyp);
    fAlertToast("SUCCESS", "Successfully Saved");
  }
};
export const getTransItemStockUOM = async (
  setTransItemStockObj,
  xB_Itmcd,
  xB_Unit,
  xLoc
) => {
  let ApiObj = await Get_TransItemStockUOM(xB_Itmcd, xB_Unit, xLoc);
  if (ApiObj?.length > 0) {
    setTransItemStockObj({
      RPStock: ApiObj[0]?.RPStock,
      MSP: ApiObj[0].MSP,
      CostPr: ApiObj[0].CostPr,
      LPRate: ApiObj[0].LPRate,
    });
  }
};
